import { createContext } from "react";
import { IHierarchyStatusContext } from "./hierarchy/interface";

export const HierarchyContext = createContext<IHierarchyStatusContext | null>(null);
